module.exports = __webpack_public_path__ + "img/default-avatar.00fa42a8.jpg";